import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-productvariation',
  templateUrl: './productvariation.component.html',
  styleUrls: ['./productvariation.component.css']
})
export class ProductvariationComponent implements OnInit {


  @Input() doctype: string;
  @Input() req: {};
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() msgboxtype: string;
  @Output() emitData = new EventEmitter();

  @Input() productvariationsid: number = 0;
  @Input() productid: number = 0;
  @Input() variationsname: string = '';
  @Input() uomid: number = null;
  @Input() sizeid: number = null;
  @Input() uomqty: number = 0;
  @Input() price: number = 0;
  @Input() cost: number = 0;
  @Input() isoutofstock: number = 0;
  @Input() sp1: number = null;
  @Input() sp2: number = null;
  @Input() sp3: number = null;
  @Input() sp4: number = null;
  @Input() sp5: number = null;
  @Input() sp6: number = null;
  @Input() sp7: number = null;
  @Input() sp8: number = null;
  @Input() sp9: number = null;
  @Input() sp10: number = null;
  @Input() inactive: number = 0;

  productvariationform = new FormGroup({
    productid: new FormControl(0),
    variationsname: new FormControl(''),
    uomid: new FormControl(null),
    sizeid: new FormControl(null, Validators.required),
    uomqty: new FormControl(0),
    price: new FormControl(0),
    cost: new FormControl(0),
    isoutofstock: new FormControl(false),
    sp1: new FormControl(null),
    sp2: new FormControl(null),
    sp3: new FormControl(null),
    sp4: new FormControl(null),
    sp5: new FormControl(null),
    sp6: new FormControl(null),
    sp7: new FormControl(null),
    sp8: new FormControl(null),
    sp9: new FormControl(null),
    sp10: new FormControl(null),
    inactive: new FormControl(false),
  });

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Master
  uomColl: any = [];
  sizeColl: any = [];
  pricetypeColl: any = [];

  issp1: boolean = false;
  issp2: boolean = false;
  issp3: boolean = false;
  issp4: boolean = false;
  issp5: boolean = false;
  issp6: boolean = false;
  issp7: boolean = false;
  issp8: boolean = false;
  issp9: boolean = false;
  issp10: boolean = false;


  sp1displayname: string = '';
  sp2displayname: string = '';
  sp3displayname: string = '';
  sp4displayname: string = '';
  sp5displayname: string = '';
  sp6displayname: string = '';
  sp7displayname: string = '';
  sp8displayname: string = '';
  sp9displayname: string = '';
  sp10displayname: string = '';

  currencyMask:any="";

  constructor(private activeModal: NgbActiveModal, private appService: DhukanDataService,
    private loginService: LoginDataService, private toastr: ToastrService) { 
      this.currencyMask=this.loginService.fngetDecimalPlaces()
    }

  ngOnInit() {

    this.fngetUom();
    this.fngetSize();
    this.fngetPricetype()
  }

  public fnInitializeProductFormGroup() {
    this.productvariationform.patchValue({
      productid: this.productid,
      variationsname: this.variationsname,
      uomid: this.uomid,
      uomqty: this.uomqty,
      price: this.price,
      cost: this.cost,
      isoutofstock: this.isoutofstock,
      sizeid: this.sizeid,
      sp1: this.sp1,
      sp2: this.sp2,
      sp3: this.sp3,
      sp4: this.sp4,
      sp5: this.sp5,
      sp6: this.sp6,
      sp7: this.sp7,
      sp8: this.sp8,
      sp9: this.sp9,
      sp10: this.sp10,
      inactive: this.inactive,
    })


  }

  fngetPricetype() {
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.pricetypeColl = res.json().result;



            for (let abo of this.pricetypeColl) {
              if (abo.pricetag === 'SP1') {
                this.issp1 = true
                this.sp1displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP2') {
                this.issp2 = true
                this.sp2displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP3') {
                this.issp3 = true
                this.sp3displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP4') {
                this.issp4 = true
                this.sp4displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP5') {
                this.issp5 = true
                this.sp5displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP6') {
                this.issp6 = true
                this.sp6displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP7') {
                this.issp7 = true
                this.sp7displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP8') {
                this.issp8 = true
                this.sp8displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP9') {
                this.issp9 = true
                this.sp9displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP10') {
                this.issp10 = true
                this.sp10displayname = abo.pricetypename
              }
            }

          }

        },

        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetSize() {
    var data = {
      'sizeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getSize(data)
      .subscribe(
        (res) => {
          this.sizeColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetUom() {
    var data = {
      'uomid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getUom(data)
      .subscribe(
        (res) => {
          this.uomColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      this.submitted = true;
      this.successfully = false;


      //Validate
      if (this.productvariationform.valid) {

        this.fnShowProgress();

        //Check
        var data = {
          'productvariationsid': this.productvariationsid,
          'productid': this.productid,
          'variationsname': this.productvariationform.get('variationsname').value,
          'uomid': this.productvariationform.get('uomid').value,
          'uomqty': this.productvariationform.get('uomqty').value,
          'price': this.productvariationform.get('price').value,
          'isoutofstock': this.productvariationform.get('isoutofstock').value,
          'cost': this.productvariationform.get('cost').value,
          'sizeid': this.productvariationform.get('sizeid').value,
          'sp1': this.productvariationform.get('sp1').value,
          'sp2': this.productvariationform.get('sp2').value,
          'sp3': this.productvariationform.get('sp3').value,
          'sp4': this.productvariationform.get('sp4').value,
          'sp5': this.productvariationform.get('sp5').value,
          'sp6': this.productvariationform.get('sp6').value,
          'sp7': this.productvariationform.get('sp7').value,
          'sp8': this.productvariationform.get('sp8').value,
          'sp9': this.productvariationform.get('sp9').value,
          'sp10': this.productvariationform.get('sp10').value,
          'inactive': this.productvariationform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
        this.appService.fnCheckProductVariations(data).subscribe(
          (res) => {

            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              this.emitData.emit(data);
              this.activeModal.close(true);
            }
            else if (_checkresult === "name") {

              this.productvariationform.controls['sizeid'].setErrors({ 'notfound': true });
            }
          });

      }
    } catch (ex) {


      this.fnHideProgress();
      this.fnShowErrorMsg(ex);
    }
  }


  public decline() {
    this.activeModal.dismiss();
  }





  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    //console.log(ex)
    this.toastr.warning('Internal Error', ex);
  }



}
